<div class="product-list container">
  <div class="product-list__header">
    <div class="product-list__header--title">
      {{ titleSearch }}

      @if (productList$ | async; as productList) {
        @if (productList.length > 0) {
          ({{ totalProducts$ | async }})
        }
        @if (didYouMean$ | async; as didYouMean) {
          <p class="product-list__header--title--didYouMean">
            {{ 'product.didYouMean' | translate }} <button (click)="didYouMeanChangeSearch(didYouMean)">{{ didYouMean }}</button> ?
          </p>
        }
      }
    </div>

    @if (productList$ | async; as productList) {
      @if (productList.length > 0) {
        <div class="product-list__header--controls">
          <sort />
          <view-config [changeView]="selectGridOption.bind(this)" [gridOption$]="gridOption$" />
        </div>
      }
    }
  </div>

  @if (isLoading$ | async) {
    <div class="product-list__loading">
      <local-loader />
    </div>
  } @else {
    @if (productList$ | async; as productList) {
      @if (productList.length > 0) {
        <div class="product-list__body">
          <div class="product-list__body--sidebar {">
            <facets />
            <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.BANNER_GRID" />
          </div>

          <div class="product-list__body--content">
            @if ((gridOption$ | async) === 'grid') {
              <div class="product-list__body--grid">
                @for (product of productList; track $index) {
                  <div cxInViewport (visibleChange)="onItemVisible($event, $index)" class="product-viewport-wrapper" #viewPort>
                    <ng-container *ngIf="visibleFlags[$index]; else loading">
                      <product-card [index]="$index" [product]="product"></product-card>
                    </ng-container>

                    <ng-template #loading>
                      <product-loading></product-loading>
                    </ng-template>
                  </div>
                }
              </div>
            } @else {
              <div class="product-list__body--table">
                <columns-config />
                <cx-products-table />
              </div>
            }

            <div class="product-list__body--pagination">
              <pagination
                [currentPage]="(currentPage$ | async)!"
                [totalPages]="(totalPages$ | async)!"
                (changePage)="onPageChange($event)"
              />
            </div>

            <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.PRODUCT_CAROUSEL" />
          </div>
        </div>
      }
    } @else {
      <div class="product-list__empty-message">{{ 'search.errorMessage' | translate }}</div>
    }
  }
</div>
